
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { Item } from "@/types/responses/inserzione/ResponseInserzioneInterface";
@Component
export default class InformazioniVendita extends Vue {
  @Prop() item!: Item;
  @Prop() luogoVendita!: any;
}
